module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_Daniel_Pancerz.60334167.jpg";